/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Freeze_Confirm_InvoicesInputs */



/**
* | output |
* | --- |
* | "Reports already claimed by an issued invoice stay visible and keep reconciling." |
*
* @param {Partner_Org_Freeze_Confirm_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_freeze_confirm_invoices = /** @type {((inputs?: Partner_Org_Freeze_Confirm_InvoicesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Freeze_Confirm_InvoicesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereits fakturierte Berichte bleiben sichtbar und weiterhin abstimmbar.")
	return /** @type {LocalizedString} */ ("Reports already claimed by an issued invoice stay visible and keep reconciling.")
});